import jwtDecode from "jwt-decode";
import { createSocketUser, disconnectSocket } from "./socketConnectivity";
export const getAuthToken = () => localStorage.getItem("hr_token");
export const setAuthToken = (token) =>
  localStorage.setItem("hr_token", token);
export const removeAuthToken = () => {
  const { status, decoded } = decodeJWT(getAuthToken());
  if (!status) return { status: false };
  const userId = decoded[`${decoded["type"]}Id`];
  disconnectSocket(userId);
  return sessionStorage.removeItem("hr_token");
};

export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Array.isArray(value) && value.length === 0) ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

export const decodeJWT = (token) => {
  try {
    const decoded = jwtDecode(token.replace("Bearer ", ""));
    if (isEmpty(decoded)) {
      return {
        status: false,
      };
    }

    return {
      status: true,
      decoded,
    };
  } catch (err) {
    console.log(err, "error in login");
    return {
      status: false,
    };
  }
};

export const isLogin = () => {
  try {
    let token = getAuthToken();

    if (isEmpty(token)) return { status: false };
    const { status, decoded } = decodeJWT(token);

    // window.alert(decoded);
    if (!status) return { status: false };
    return { status, decoded };
  } catch (err) {
    return { status: false };
  }
};

export const socketConnect = () => {
  try {
    let { status, decoded } = isLogin();
    if (!status) return false;
    const userId = decoded._id;

    return createSocketUser(userId);
  } catch (error) {
    // return false;
    console.log(error, "error");
  }
};

export const socketConnectBackup = (defaultToken = "") => {
  try {
    if (!isEmpty(defaultToken)) {
      // LOGIN INITIAL
      const { status, decoded } = decodeJWT(defaultToken);

      if (!status) return false;
      const userId = decoded[`${decoded["type"]}Id`];
      return createSocketUser(userId);
    } else {
      // PAGE REFRESH
      let { status, decoded } = isLogin();
      if (!status) return false;
      const userId = decoded[`${decoded["type"]}Id`];
      return createSocketUser(userId);
    }
  } catch (error) {
    return false;
  }
};
